import UserApartmentsAccessGroupsList from './UserApartmentsAccessGroupsList';

export default UserApartmentsAccessGroupsList;
